import InfiniteScroll from "react-infinite-scroll-component";
import MongoliaDataBody from "./MongoliaDataBody";
import MongoliaDataHeader from "./MongoliaDataHeader";
import ScrollToTop from "components/common/ScrollToTop/ScrollToTop";
import classNames from "classnames";
import { useEffect, createRef } from "react";
import * as styles from "./MongoliaData.module.scss";
import {
  storeScrollPosition,
  fetchStoredScrollPosition,
} from "common/utils/utils";

const MongoliaDataTable = ({
  fetchNextPage,
  lastPage,
  hasNextPage,
  mongoliaData,
  isLoading,
  noDataFound,
  extraClass,
}) => {
  const tableRef = createRef();

  const tableclasses = classNames(
    "Table_Wrapper",
    styles[extraClass],
    styles.List_Scroll_Table
  );
  const containerClasses = { overflow: "default" };

  useEffect(() => {
    setTimeout(() => {
      fetchStoredScrollPosition("scrollable-table", "MONGOlIAN_PROGRAM");
    }, 100);
  }, []);

  return (
    <section id="scrollable-table" className={tableclasses} ref={tableRef}>
      <InfiniteScroll
        style={containerClasses}
        loader={!isLoading && <h4 className="Font_H8">Loading...</h4>}
        next={fetchNextPage}
        dataLength={isLoading ? 0 : lastPage * mongoliaData.length}
        hasMore={hasNextPage}
        onScroll={(event) => storeScrollPosition(event, "MONGOlIAN_PROGRAM")}
        scrollableTarget="scrollable-table">
        <table className="Table overflow-auto">
          <MongoliaDataHeader />
          {!isLoading && !noDataFound && (
            <MongoliaDataBody {...{ mongoliaData }} />
          )}
        </table>
      </InfiniteScroll>
      <ScrollToTop />
    </section>
  );
};

export default MongoliaDataTable;
